module.exports = __webpack_public_path__ + "static/media/sort-blue.0757f0fa.svg";